// Campus photo for /colleges/johns-hopkins-university: CC BY 2.0, by chris.rycroft, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AGilman_Hall_and_the_Keyser_Quad.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/johns-hopkins-university/; credited under the photo.
const photo = {
    "slug": "johns-hopkins-university",
    "alt": "Gilman Hall and its clock tower across the Keyser Quad at Johns Hopkins University in Baltimore, Maryland",
    "src": "/colleges/johns-hopkins-university/campus-1600.webp",
    "srcSmall": "/colleges/johns-hopkins-university/campus-800.webp",
    "srcMid": "/colleges/johns-hopkins-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/johns-hopkins-university/og.jpg",
    "title": "Gilman Hall and the Keyser Quad",
    "author": "chris.rycroft",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AGilman_Hall_and_the_Keyser_Quad.jpg",
    "read": "2026-10-01"
};

export default photo;
